export default __webpack_public_path__ + "static/media/2017 LV BOOTH EXPLANATION-03.a477cea8.jpg";